import React, {
  ReactNode,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";

import XHFormInput, { FocusHandler } from "../FormInput";
import { checkBankCard, creditCard } from "../../utils";
import "./index.scss";
import { XHComponentCommonProps } from "../../types";

export type PhoneNumberInputProps = {
  showScan?: boolean;
  label?: string;
  /**
   * 只有在direction为column才生效
   */
  bankName?: ReactNode;
  onChange?: (value: string) => void;
  value: string;
  placeholder?: string;
  readOnly?: boolean;
  disabled?: boolean;
  direction?: "column" | "row";
  onScan?: () => void;
  onError?: (msg: string) => void;
  maxlength?: number;
  slot?: ReactNode;
  border?: boolean;
  onBlur?: () => void;
} & XHComponentCommonProps;

export type BankCardNumberInputRef = { isValid: boolean; focus: () => void };

const BankCardNumberInput = forwardRef<
  BankCardNumberInputRef,
  PhoneNumberInputProps
>((props, fromRef) => {
  const {
    showScan = false,
    label,
    value,
    bankName,
    readOnly,
    direction = "column",
    onScan,
    placeholder = "请输入银行卡号",
    onError,
    onChange,
    maxlength = 23,
    slot,
    className,
    border,
    onBlur,
  } = props;

  const validateCardNumber = value => {
    const newVal = value.replace(/\s/g, "");
    if (newVal.length < 16 || newVal.length > 19) return false;
    return checkBankCard(newVal);
  };

  const FormInput = useRef<FocusHandler>(null);

  const handleBlur = value => {
    console.log("blur");
    onBlur?.();
    if (!validateCardNumber(value))
      onError?.(value === "" ? "银行卡号不能为空" : "银行卡号格式不正确");
  };

  const handleChange = value => {
    const formatValue = creditCard(value);
    onChange?.(formatValue);
  };

  const handleOnScan = () => {
    console.log(fromRef, "fromRef...");
    onScan?.();
  };

  useImperativeHandle(
    fromRef,
    () => {
      return {
        isValid: validateCardNumber(value),
        focus: () => {
          FormInput?.current?.focus();
        },
      };
    },
    [value]
  );

  return (
    <View className={classNames("xh-bankcard-number-input", className)}>
      <XHFormInput
        padding
        ref={FormInput}
        RightComponent={
          showScan && (
            <View
              onClick={handleOnScan}
              className="xh-bankcard-number-input-scan"
            ></View>
          )
        }
        direction={direction}
        label={label}
        mainExtra={
          direction !== "row" && (
            <View className="xh-bankcard-number-input-name">{bankName}</View>
          )
        }
        maxlength={maxlength}
        placeholder={placeholder}
        readonly={readOnly}
        type="tel"
        border={border}
        value={creditCard(value)}
        onBlur={handleBlur}
        onChange={handleChange}
      />
      {slot && <View className="xh-bankcard-number-input-slot">{slot}</View>}
    </View>
  );
});

export default BankCardNumberInput;
